import React from 'react';
import stylesheet from './Panel.scss';
import classnames from 'classnames';

const asTypes = {
  standard: 'standard',
  standardNoHover: 'standard-no-hover',
  flat: 'flat',
  flatNoHover: 'flat-no-hover',
  overlay: 'overlay',
  dark: 'dark',
  empty: 'empty',
  emptyPaper: 'empty-paper',
  transparent: 'transparent',
};

const Panel = ({ children, as = 'standard', linkHref, target, dataHook }) => {
  const asClasses = classnames([
    stylesheet['panel'],
    stylesheet[`panel--${asTypes[as]}`],
  ]);

  return (
    <div className={asClasses} data-hook={dataHook}>
      {children}
      {linkHref && (
        <a
          className={stylesheet['panel__link']}
          href={linkHref}
          target={target}
          rel={target === '_blank' ? 'noopener noreferrer' : null}
        />
        // TODO: Add accessible content in here
      )}
    </div>
  );
};

export default Panel;
